// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1_Xtp","cell":"ColumnAccessor_cell__2RToK","firstCellAccent":"ColumnAccessor_firstCellAccent__3-CzI"};